import React, { useEffect, useRef } from 'react';

/**
 * Lightweight click-anchored popover used by the filter chips.
 * Closes on outside click and on Escape.
 */
export default function Popover({ open, onClose, anchorRef, children, align = 'left' }) {
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        function onDocClick(e) {
            if (!ref.current || ref.current.contains(e.target)) return;
            if (anchorRef?.current && anchorRef.current.contains(e.target)) return;
            onClose();
        }
        function onKey(e) {
            if (e.key === 'Escape') onClose();
        }
        document.addEventListener('mousedown', onDocClick);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDocClick);
            document.removeEventListener('keydown', onKey);
        };
    }, [open, onClose, anchorRef]);

    if (!open) return null;

    return (
        <div ref={ref} className={`v3-df-popover v3-df-popover-${align}`} role="dialog">
            {children}
        </div>
    );
}
